(() => {
  const initialize = (root) => {
    if (!root || root.dataset.ppInitialized === 'true') return;
    root.dataset.ppInitialized = 'true';

    const grid = root.querySelector('[data-pp-review-grid]');
    const filters = [...root.querySelectorAll('[data-pp-filter]')];
    const search = root.querySelector('[data-pp-search]');
    const sort = root.querySelector('[data-pp-sort]');
    const showMore = root.querySelector('[data-pp-show-more]');
    const openForm = root.querySelector('[data-pp-open-form]');
    const formWrap = root.querySelector('[data-pp-review-form]');
    const countLabel = root.querySelector('[data-pp-result-count]');
    if (!grid) return;

    let activeRating = 'all';
    let visibleLimit = 6;

    const cards = () => [...grid.querySelectorAll('[data-pp-review]')];

    const matchingCards = () => {
      const query = (search?.value || '').trim().toLowerCase();
      return cards().filter((card) => {
        const ratingMatch = activeRating === 'all' || card.dataset.rating === activeRating;
        const haystack = `${card.dataset.author || ''} ${card.dataset.location || ''} ${card.dataset.text || ''}`;
        return ratingMatch && (!query || haystack.includes(query));
      });
    };

    const apply = () => {
      const matches = matchingCards();
      const matchSet = new Set(matches.slice(0, visibleLimit));
      cards().forEach((card) => { card.hidden = !matchSet.has(card); });
      if (showMore) showMore.hidden = matches.length <= visibleLimit;
      if (countLabel) countLabel.textContent = matches.length
        ? `Showing ${Math.min(visibleLimit, matches.length)} of ${matches.length} matching reviews`
        : 'No reviews match this filter.';
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeRating = button.dataset.ppFilter || 'all';
        visibleLimit = 6;
        filters.forEach((item) => item.classList.toggle('is-active', item === button));
        apply();
      });
    });

    search?.addEventListener('input', () => { visibleLimit = 6; apply(); });

    sort?.addEventListener('change', () => {
      const ordered = cards().sort((a, b) => {
        if (sort.value === 'high') return Number(b.dataset.rating) - Number(a.dataset.rating) || Number(a.dataset.index) - Number(b.dataset.index);
        if (sort.value === 'low') return Number(a.dataset.rating) - Number(b.dataset.rating) || Number(a.dataset.index) - Number(b.dataset.index);
        return Number(a.dataset.index) - Number(b.dataset.index);
      });
      ordered.forEach((card) => grid.appendChild(card));
      apply();
    });

    showMore?.addEventListener('click', () => { visibleLimit += 6; apply(); });

    openForm?.addEventListener('click', () => {
      if (!formWrap) return;
      formWrap.classList.toggle('is-open');
      openForm.textContent = formWrap.classList.contains('is-open') ? 'Close review form' : 'Write a review';
      if (formWrap.classList.contains('is-open')) {
        formWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => formWrap.querySelector('input, select, textarea')?.focus(), 350);
      }
    });

    apply();
  };

  const initializeAll = () => document.querySelectorAll('[data-pp-reviews-root]').forEach(initialize);
  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
})();
